module.exports = __webpack_public_path__ + "0aa0901cbfd5953d05fd09f168eeb16e.pdf";